module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page_home"
  }, [_c('div', {
    staticStyle: {
      "height": "80px"
    },
    attrs: {
      "id": "page-top"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', {
    staticClass: "banner1"
  }, [_c('div', [_c('h2', [_vm._v("致力于为经销商集团")]), _vm._v(" "), _c('h2', [_vm._v("拓展二手车业务提供服务")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('p', [_vm._v("拉风汽车依托专业的二手车评估技术、强大的风控体系、数据模型以及监控措施，提供数据挖掘及整合处理技术，帮助其提高效率并降低运营成本")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/imgs/banner2.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "banner2"
  }, [_c('div', [_c('h2', [_vm._v("致力于为金融机构")]), _vm._v(" "), _c('h2', [_vm._v("开拓二手车金融业务提供服务")]), _vm._v(" "), _c('span'), _vm._v(" "), _c('p', {
    on: {
      "click": _vm.download
    }
  }, [_vm._v("了解详情")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/imgs/banner4.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('swiper-slide', {
    staticClass: "banner3"
  }, [_c('div', {
    staticClass: "banner-img"
  }, [_c('h2', [_vm._v("拉风汽车已覆盖全国50个城市、700余家4s店")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/imgs/banner-03@1x.png")
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    slot: "pagination"
  })], 1), _vm._v(" "), _c('assess-item', {
    attrs: {
      "id": "assess"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "home_intro"
  }, [_c('ul', [_c('li', [_c('h3', [_vm._v("一站式汽车金融服务平台")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "join"
  }, [_c('div', {
    staticClass: "sp"
  }, [_c('img', {
    staticClass: "sp_bg_img",
    attrs: {
      "src": require("../assets/imgs/img_sp.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/ic_sp.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('small'), _vm._v(" "), _c('span', [_vm._v("为金融机构提供服务")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.oldcar = true
      }
    }
  }, [_vm._v("点击申请")])])]), _vm._v(" "), _c('div', {
    staticClass: "jxs"
  }, [_c('img', {
    staticClass: "sp_bg_img",
    attrs: {
      "src": require("../assets/imgs/img_jingxiaoshang.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../assets/imgs/ic_jingxiaoshang.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('small'), _vm._v(" "), _c('span', [_vm._v("为经销商提供服务")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.dealer = true
      }
    }
  }, [_vm._v("点击申请")])])])])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v("合作伙伴")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "join-work"
  }, _vm._l((_vm.fellows), function(fellow) {
    return _c('li', {
      key: fellow.hover
    }, [_c('img', {
      attrs: {
        "src": fellow.pub,
        "alt": ""
      }
    }), _vm._v(" "), _c('img', {
      attrs: {
        "src": fellow.hover,
        "alt": ""
      }
    })])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "oldcar"
  }, [_c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.oldcar
    },
    on: {
      "update:visible": function($event) {
        _vm.oldcar = $event
      }
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("二手车经销商加盟")]), _vm._v(" "), _c('span', [_vm._v("("), _c('small', [_vm._v("*")]), _vm._v("号为必填项)")])]), _vm._v(" "), _c('el-form', {
    ref: "oldcarForm",
    attrs: {
      "model": _vm.oldcarForm,
      "rules": _vm.oldcars,
      "label-width": "5px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "name",
      "label": " "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.oldcarForm.name),
      callback: function($$v) {
        _vm.oldcarForm.name = $$v
      },
      expression: "oldcarForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "linkman",
      "label": " "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系人"
    },
    model: {
      value: (_vm.oldcarForm.linkman),
      callback: function($$v) {
        _vm.oldcarForm.linkman = $$v
      },
      expression: "oldcarForm.linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "phone",
      "label": " "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.oldcarForm.phone),
      callback: function($$v) {
        _vm.oldcarForm.phone = _vm._n($$v)
      },
      expression: "oldcarForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "eml",
      "label": " "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "邮箱"
    },
    model: {
      value: (_vm.oldcarForm.eml),
      callback: function($$v) {
        _vm.oldcarForm.eml = $$v
      },
      expression: "oldcarForm.eml"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "region",
      "label": " "
    }
  }, [_c('el-input', {
    staticClass: "show",
    attrs: {
      "placeholder": "销售区域(**省**市)"
    },
    model: {
      value: (_vm.oldcarForm.region),
      callback: function($$v) {
        _vm.oldcarForm.region = $$v
      },
      expression: "oldcarForm.region"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "remark",
      "label": " "
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "备注"
    },
    model: {
      value: (_vm.oldcarForm.remark),
      callback: function($$v) {
        _vm.oldcarForm.remark = $$v
      },
      expression: "oldcarForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.subOldCar()
      }
    }
  }, [_vm._v("立即申请")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dealer"
  }, [_c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "visible": _vm.dealer
    },
    on: {
      "update:visible": function($event) {
        _vm.dealer = $event
      }
    }
  }, [_c('div', {
    staticClass: "formTitle"
  }, [_c('h1', [_vm._v("经销商集团合作申请")]), _vm._v(" "), _c('span', [_vm._v("("), _c('small', [_vm._v("*")]), _vm._v("号为必填项)")])]), _vm._v(" "), _c('el-form', {
    ref: "dealerForm",
    attrs: {
      "model": _vm.dealerForm,
      "label-width": "5px",
      "rules": _vm.dealers
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "公司名称"
    },
    model: {
      value: (_vm.dealerForm.name),
      callback: function($$v) {
        _vm.dealerForm.name = $$v
      },
      expression: "dealerForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "store"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "店面数量"
    },
    model: {
      value: (_vm.dealerForm.store),
      callback: function($$v) {
        _vm.dealerForm.store = _vm._n($$v)
      },
      expression: "dealerForm.store"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "brand"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "主营品牌"
    },
    model: {
      value: (_vm.dealerForm.brand),
      callback: function($$v) {
        _vm.dealerForm.brand = $$v
      },
      expression: "dealerForm.brand"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "region",
      "label": " "
    }
  }, [_c('el-input', {
    staticClass: "show",
    attrs: {
      "placeholder": "销售区域(**省**市)"
    },
    model: {
      value: (_vm.dealerForm.region),
      callback: function($$v) {
        _vm.dealerForm.region = $$v
      },
      expression: "dealerForm.region"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "linkman"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "联系人"
    },
    model: {
      value: (_vm.dealerForm.linkman),
      callback: function($$v) {
        _vm.dealerForm.linkman = $$v
      },
      expression: "dealerForm.linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "phone",
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.dealerForm.phone),
      callback: function($$v) {
        _vm.dealerForm.phone = _vm._n($$v)
      },
      expression: "dealerForm.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "eml"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "邮箱"
    },
    model: {
      value: (_vm.dealerForm.eml),
      callback: function($$v) {
        _vm.dealerForm.eml = $$v
      },
      expression: "dealerForm.eml"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "备注"
    },
    model: {
      value: (_vm.dealerForm.remark),
      callback: function($$v) {
        _vm.dealerForm.remark = $$v
      },
      expression: "dealerForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.subDealer()
      }
    }
  }, [_vm._v("立即申请")])], 1)], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/assicon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("更精准的二手车评估能力")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/controlicon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("更安全便捷的风控手段")])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/customicon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("更强大的定制开发能力")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bor dis"
  }, [_c('span', {
    staticClass: "borl"
  }), _c('span'), _c('span', {
    staticClass: "borr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("对接大型经销商集团等优质客户。"), _c('br'), _vm._v("贷中监管、贷后催收。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("精准评估，二手车非标资产标准化。"), _c('br'), _vm._v("业务以库存金融为主，消费金融为辅。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "bor"
  }, [_c('span', {
    staticClass: "borl"
  }), _c('span', [_vm._v("互惠互利 精诚合作")]), _c('span', {
    staticClass: "borr"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-717fa4c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 205
// module chunks = 1